import { Parameter } from '@angular/fire/compat/remote-config';
import { environment } from '../../../environments/environment';
import * as actions from './remote-config.actions';
import { Value } from '@angular/fire/remote-config';

// :Note: If introducing a remote config variable on Firebase, please update:
// * The RemoteConfigState interface (below)
// * The default environment values (Environment.ts)
export interface RemoteConfigState {
  memoriam_music_options: string[];
  show_config_list: boolean;
  preferred_countries: string[];
  web_family_representative: boolean;
  web_configure_2fa: boolean;
  web_wrapped_enabled: boolean;
  wrapped_year: string;
  web_sensitive_memos: boolean;
}

// :Note: If any environment variables are found to have values of an incorrect
// type, this will throw a type conversion error.
const INITIAL_STATE: RemoteConfigState = environment.firebase.remoteConfig;

export function reducer(state: RemoteConfigState = INITIAL_STATE, action: actions.SetRemoteConfig) {
  switch (action.type) {
    case actions.SET_REMOTE_CONFIG:
      return SetRemoteConfigValues(action.payload, state);
    default:
      return state;
  }
}

// Casts a given Firebase Parameter to the type found in our environment values.
function SetRemoteConfigValues(value: Record<string, Value>, oldState: RemoteConfigState) {
  const newState: RemoteConfigState = { ...oldState };
  for (let key of Object.keys(value)) {
    if (key in environment.firebase.remoteConfig) {
      switch (typeof environment.firebase.remoteConfig[key]) {
        case 'string':
          newState[key] = value[key].asString();
          break;
        case 'number':
          newState[key] = value[key].asNumber();
          break;
        case 'boolean':
          newState[key] = value[key].asBoolean();
          break;
        case 'object':
          newState[key] = JSON.parse(value[key].asString());
        default:
          // There exists a case where incoming keys won't match our existing
          // data. This could be because of remote config keys for other
          // platforms. Because of this, we ignore the incoming data.
          break;
      }
    }
  }
  return newState;
}
